export default __webpack_public_path__ + "static/media/DSC_7786.31074817.jpg";